import { createFileRoute } from '@tanstack/react-router';
import type { KioskTypes } from '@frontend/digital-forms-ui';
import { i18next } from '@frontend/i18n';
import { KioskFormsPage } from '../pages';

export interface SearchParams {
  patientType?: KioskTypes.Patron;
}

export const Route = createFileRoute('/kiosk/forms_/$locationId')({
  component: KioskFormsPage,
  validateSearch: (search: SearchParams): SearchParams => {
    return search;
  },
  head: () => ({
    meta: [
      {
        title: i18next.t('Select Form', { ns: 'digital-forms-experience' }),
      },
    ],
  }),
});
